import * as api from 'dashboard/resources/earnings-history.api';
import actionTypes from './action-types';

export const fetchEarningsHistoryRequest = () => ({
  type: actionTypes.FETCH_EARNINGS_HISTORY_REQUEST,
  name: 'earningsHistoryLoadingStatus',
});

export const fetchEarningsHistorySuccess = (data) => ({
  type: actionTypes.FETCH_EARNINGS_HISTORY_SUCCESS,
  name: 'earningsHistoryLoadingStatus',
  data,
});

export const fetchEarningsHistoryFailure = () => ({
  type: actionTypes.FETCH_EARNINGS_HISTORY_FAILURE,
  name: 'earningsHistoryLoadingStatus',
});

export const fetchEarningsHistory =
  ({ filters }) =>
  async (dispatch, getState) => {
    try {
      const { session } = getState();
      const retailerId = filters.retailerId || session.retailer.retailerId;

      const params = {
        ...filters,
        retailerId,
      };

      dispatch(fetchEarningsHistoryRequest());
      const data = await api.fetchEarningsHistory(params);
      dispatch(fetchEarningsHistorySuccess(data));
    } catch (error) {
      console.error('FETCH_EARNINGS_HISTORY', error);
      dispatch(fetchEarningsHistoryFailure());
    }
  };

export const downloadEarningsHistoryReportRequest = () => ({
  type: actionTypes.DOWNLOAD_EARNINGS_HISTORY_REPORT_REQUEST,
});

export const downloadEarningsHistoryReportSuccess = () => ({
  type: actionTypes.DOWNLOAD_EARNINGS_HISTORY_REPORT_SUCCESS,
});

export const downloadEarningsHistoryReportFailure = () => ({
  type: actionTypes.DOWNLOAD_EARNINGS_HISTORY_REPORT_FAILURE,
});

export const downloadEarningsHistoryReport =
  ({ extension, ...filters }) =>
  (dispatch, getState) => {
    try {
      const { session } = getState();
      const retailerId = filters.retailerId || session.retailer.retailerId;

      const params = {
        ...filters,
        retailerId,
        extension,
      };

      dispatch(downloadEarningsHistoryReportRequest());
      dispatch(downloadEarningsHistoryReportSuccess());
      return api.downloadEarningsHistoryReport(params);
    } catch (error) {
      console.error('DOWNLOAD_EARNINGS_HISTORY_REPORT', error);
      dispatch(downloadEarningsHistoryReportFailure());
    }
  };



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/earnings-history/earnings-history.actions.js